import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import Cookies from 'js-cookie'
moment.locale('fr')

import settings from '@/settings'

const ApiPlugin = {}

ApiPlugin.vuexPlugin = store => {

    class ApiObject {
        constructor(data) {
            for(let key in data) {
                if (key == 'start_date' || key == 'end_date' || key == 'pub_date') {
                    this[key] = moment(data[key])
                } else {
                    this[key] = data[key]
                }
                this.id = this.id || this.django_id
            }
        }
    }

    class Article extends ApiObject {
        getEventData() {
            let data = {id: this.id, title: this.title}
            if (this.authors.length) {
                data.author=this.authors[0].slug
            }
            return data
        }
    }

    class Schedule extends ApiObject {
        getEventData() {
            let data = {id: this.video_id, title: this.title}
            if (this.authors.length) {
                data.author=this.authors[0].slug
            }
            return data
        }

        isTeaser() {
            return this.tags && this.tags.filter(x=>x.slug=='teaser').length > 0
        }

        deleteSchedule() {
            return api.delete('/schedules/'+this.id+'/')
            /*   $.ajax({
                url: 'https://www.{{ settings.BASE_DOMAIN }}/rest/schedules/'+scheduleId+'/',
                type: 'DELETE',
                success: function(result) {
                    window.location.reload()
                },
                headers: {
                    "X-CSRFTOKEN": csrftoken,
                },
                xhrFields: {
                  withCredentials: true
                }
            });*/
        }
    }

    class HtmlModule extends ApiObject {
        constructor(...args) {
            super(...args)
            this.json = {}
            if (this.params.x_json) {
                try {
                    this.json = JSON.parse(this.params.x_json)
                } catch (e) {
                    console.log("JSON error", e)
                }
            }
        }
    }

    let CLASS_MAPPING = {
        'Schedule': Schedule,
        'HtmlModule': HtmlModule,
    }

    class ArticlePaginator {
        constructor(articles, total, nextCall) {
            this.articles = articles
            this.total = total
            this.nextCall = nextCall
        }
        next() {
            return this.nextCall.method(this.nextCall.params)
        }
        get hasMore() {
            return !!this.nextCall
        }
        all() {
            if (this.hasMore) {
                return this.next().then(paginator => {
                    return paginator.all().then(results => {
                        return this.articles.concat(results)
                    })
                })
            } else {
                return new Promise(resolve => {
                    resolve(this.articles)
                })
            }
        }
    }

    function createClass(data, restBase) {
        let cls = CLASS_MAPPING[data.model] || Article
        let obj = new cls(data)
        obj.restBase = restBase
        return obj
    }
    function createModel(modelSettings) {
        const modelName = modelSettings.modelName,
            restBase = '/' + (modelSettings.restBase || (modelName.toLowerCase() + 's')) + '/'
        const methods = {
            get: function(id) {
                return api.get(restBase + id + '/').then(result => createClass(result.data, restBase))
            },
            by_slug: function(slug) {
                return api.get(restBase + 'by_slug/?slug=' + slug).then(result => createClass(result.data, restBase))
            },
            _paginated: function(endPoint, params, method) {
                let queryParams = {}
                if (modelSettings.params) _.assign(queryParams, modelSettings.params)
                if (params) _.assign(queryParams, params)
                queryParams.limit = params.limit || 10
                queryParams.offset = params.offset || 0
                return api.get(restBase + endPoint, queryParams).then(result => {
                    var next = null
                    queryParams.offset += queryParams.limit
                    if (result.data.count > queryParams.offset) {
                        next = {method: method, params: queryParams}
                    }
                    return new ArticlePaginator(
                        result.data.results.map(a => createClass(a, restBase)),
                        result.data.count,
                        next,
                    )
                })
            },
            filter: function(params) {
                return methods._paginated('', params, methods.all)
            },
            search: function(params) {
                return methods._paginated('search/', params, methods.search)
            }
        }
        return methods
    }

    var api = {
        options: settings,
        client: null,
        userToken: null,
        setUserToken: function(userToken) {
            api.userToken = userToken
            api.createClient()
        },
        createClient: function() {
            var headers = {}
            if (api.userToken) {
                headers['Authorization'] = 'Token '+api.userToken
            }
            if (settings.appCode) {
                headers['X-App-Code'] = settings.appCode
            }
            if (Cookies.get(process.env.VUE_APP_CSRF_COOKIE_NAME) && typeof(Cookies.get(process.env.VUE_APP_CSRF_COOKIE_NAME)) != 'object') {
                headers['X-CSRFTOKEN'] = Cookies.get(process.env.VUE_APP_CSRF_COOKIE_NAME)
            }

            const https = require('https');
            api.client = axios.create({
                baseURL: settings.apiBaseUrl,
                headers: headers,
                withCredentials: true,
                params: {
                    fromdomain: typeof window !== 'undefined'?window.location.hostname:'ssr',
                },
                httpsAgent: new https.Agent({
                    rejectUnauthorized: !settings.apiBaseUrl.match('.local.')
                }),
            })
            if (typeof document !== 'undefined') {
                api.client.interceptors.request.use(function (config) {
                    document.dispatchEvent(new CustomEvent('http-start'))
                    return config
                }, function (error) {
                    document.dispatchEvent(new CustomEvent('http-error'))
                    return error
                })
                api.client.interceptors.response.use(function (response) {
                    document.dispatchEvent(new CustomEvent('http-done'))
                    return response
                }, function (error) {
                    document.dispatchEvent(new CustomEvent('http-error'))
                    if (settings.showErrors) {
                        alert('Une erreur imprévue est survenue ! Merci de réessayer plus tard.')
                    }
                    return error
                })
            }
        },
        get: function(endpoint, data) {
            return api.client.get(endpoint, {params: data})
        },
        post: function(endpoint, data) {
            return api.client.post(endpoint, data)
        },
        delete: function(endpoint) {
            return api.client.delete(endpoint)
        },
        paginateData: function({url, params}) {
            let queryParams = {
                limit: 10,
                offset: 0,
            }
            if (params) {
                if (params.limit) {
                    queryParams.limit = params.limit
                }
                if (params.offset) {
                    queryParams.offset = params.offset
                }
            }
            return api.get(url, queryParams).then(result => {
                var next = null
                queryParams.offset += queryParams.limit
                if (result.data.count > queryParams.offset) {
                    next = {method: api.paginateData, params: {url, params: queryParams}}
                }
                let items = result.data.results || result.data.items
                return new ArticlePaginator(
                    items.map(a => createClass(a, url)),
                    result.data.count,
                    next,
                )
            })
        },
        fetchData: function(url) {
            return api.client.get(url).then(result => {
                if (!result.data || !result.data.items) return []
                return result.data.items.map(item => createClass(item))
            })
        },
        search: function(data) {
            return api.get('../recherche/api', data).then(response => response.data.hits.map(hit => hit['_source']), () => {})
        },
        me: function() {
            return api.get('/me/').then(response => response.data, () => {})
        },
        updateProfile(data) {
            return api.post('/me/', data).then(response => response.data)
        },
        pushSubscription: {
            set(player_id) {
                return api.post('/me/pushsubscription/' + settings.appCode, {oneSignalPlayerId: player_id})
            },
            get() {
                return api.get('/me/pushsubscription/' + settings.appCode).then(result => result.data.player_id)
            },
            delete() {
                return api.delete('/me/pushsubscription/' + settings.appCode)
            },
        },
        section: createModel({modelName: 'Section'}),
        category: createModel({modelName: 'Category', restBase: 'categories'}),
        album: createModel({modelName: 'Album'}),
        passlemot: createModel({modelName: 'Passlemot'}),
        devotional: createModel({modelName: 'Devotional'}),
        text: createModel({modelName: 'Text'}),
        audio: createModel({modelName: 'Audio'}),
        textserie: createModel({modelName: 'TextSerie'}),
        miracle: createModel({modelName: 'Miracle'}),
        video: createModel({modelName: 'Video', restBase: 'basevideos'}),
        allvideo: createModel({modelName: 'Video', params: {tags_exclude: 'exclusion-toptv'}, restBase: 'allvideos'}),
        videoKid: createModel({modelName: 'VideoKid'}),
        topPlaylist: createModel({modelName: 'Playlist', restBase:'top/playlists'}),
        myPlaylist: createModel({modelName: 'Playlist', restBase:'me/playlists'}),
        schedule: createModel({modelName: 'Schedule', restBase:'schedules'}),
        author: createModel({modelName: 'Author', restBase:'authors'}),
        module: createModel({modelName: 'Module', restBase:'modules'}),
        getYoutubeChannelLiveVideo(video_link) {
            // Try to get video id fom youtube channel live link
            let channel = video_link.replace(/.*channel=/, '').replace(/&.*/, '')
            return api.get('../bo/ytlast?channel=' + channel).then(result => {
                if (result.data.video_id) {
                    return "https://youtu.be/" + result.data.video_id
                } else {
                    return Promise.reject(new Error('Not found'))
                }
            })
        },
        login: function(provider, data) {
            return api.post('/me/login/'+provider+'/', data).then(response => {
                if (response.response) {
                    response = response.response
                }
                if (response.data.status == 'ok') {
                    store.dispatch('login', response.data)
                } else {
                    throw new Error(response.data.message)
                }
                return(response.data.status)
            })
        },
    }
    api.createClient()

    api.$store = store
    store.$api = api
}


export default ApiPlugin
